<template>
  <!-- 
    Глобальний компонент таблиці
    - 
  -->

  <b-row>
    <b-col>

      <!-- Лоадер -->
      <preloaderTable v-if="preloaderTable" />

      <!-- Єдина картка: панель інструментів + таблиця разом (без окремої картки та зайвого відступу) -->
      <b-card>

        <!--
          Панель інструментів (пошук/додати/фільтр).
          Показуємо лише коли є пагінація/пошук/фільтри — інакше приховуємо, а таблиця лишається.
        -->
        <b-row
          id="step1"
          v-if="this.showpag
              || (this.objParams && this.objParams.hasOwnProperty('search'))
              || (this.objParams && this.objParams.hasOwnProperty('pr1') && this.objParams.hasOwnProperty('pr2') && this.showCalendar == true)
              || this.dataParams?.status === true
            "
        >
          <div class="col" style="display:flex" id="limits">

            <!--
              Вибір кількості елементів на сторінці лишився один — біля пагінації (внизу таблиці).
              Тут був його повний дублікат (та сама модель limit і той самий changelimit).
            -->

            <!--
              Пошук по таблиці
              - @searchB - подія, яка спрацьовує при пошуку
              - йде перевірка на objParams, та чи містить він 'search', якщо ні, поле пошуку не буде відображено 
            -->
            <searchBox 
              @searchB="searchB" 
              v-if="this.objParams && this.objParams.hasOwnProperty('search')" 
              :typesearch="this.typesearch"
            />
            
          </div>

          <!-- Календар та фільтри -->
          <div class="col-auto d-none d-lg-flex d-xl-flex">
            <div class="hstack gap-2">
              <div>

                <!-- Кнопка для відображення календаря -->
                <button 
                  class="mainCalendarButton" 
                  v-if="this.objParams && this.objParams.hasOwnProperty('pr1') && this.objParams.hasOwnProperty('pr2')" 
                  @click="this.showCalendar = !this.showCalendar"
                  style="height: 40px;"
                >
                  {{ this.date.title }}
                </button>

                <!-- 
                  Компонент Календаря
                  - йде перевірка на objParams, та чи містить він 'pr1' та 'pr2', якщо ні, поле вказування дати не буде відображено 
                -->
                <transition name="calendarFade">
                  <filterDateTime
                    v-if="this.objParams && this.objParams.hasOwnProperty('pr1') && this.objParams.hasOwnProperty('pr2') && this.showCalendar == true"
                    @setDate="changeFilter"
                    :type="'filter'" 
                    :data="this.date"
                    key="showCalendar"
                    @close="this.showCalendar = false"
                  />
                </transition>

              </div>
            </div>
          </div>

          <!-- Кнопки по праву сторону -->
          <div class="col-auto">
            <div class="hstack gap-2">
              <div>

                <!-- Виклик модального вікна на створення, в кожному розділі викликається особисте вікно -->
                <b-button
                  v-if="this.createdform == true"
                  @click="create"
                  class="btn btn-success"
                >
                  <i class="ri-add-line align-bottom"></i>
                </b-button>
                
              </div>

              <!-- Кнопки перемикання таблиця/грід -->

                <div class="col-auto ms-sm-auto" v-if="this.objFilter && this.objFilter.checkChangeTab" >
            
                  <div class="list-grid-nav hstack gap-1" v-if="this.objFilter.checkChangeTab === true">

                      <!-- Кнопка відображення grid -->
                      <button 
                          type="button" 
                          id="grid-view-button" 
                          :class="`btn btn-soft-info nav-link btn-icon fs-14 ${typeList == 0 ? 'active' : ''} filter-button`" 
                          @click="typeList = 0, this.$emit('changeTab', typeList)"
                      >
                          <i class="ri-grid-fill"></i>
                      </button>

                      <!-- Кнопка відображення таблицею -->
                      <button 
                          type="button" 
                          id="list-view-button" 
                          :class="`btn btn-soft-info nav-link  btn-icon fs-14 ${typeList == 1 ? 'active' : ''} filter-button`" 
                          @click="typeList = 1, this.$emit('changeTab', typeList)"
                      >
                          <i class="ri-list-unordered"></i>
                      </button>
                      
                  </div>

                </div>

              <!-- Кнопки перемикання таблиця/грід -->

              <!-- 
                Фільтр для таблиці
                - йде перевірка на наявність параметрів в objParams, dataParams, та чи дорівнює статус true, якщо ні, кнопка фільтрація не буде відображена
                - :componentKey - ключ для перерендерингу блоку фільтрації при зміні даних
                - :dataParams - параметри фільтрації таблиці
                - :objParams - параметри для виклику фільтрації таблиці
                - @changeFilter - подія, яка фільтрує дані в таблиці
                - @clearFilter -  подія, для очищення фільтрів
              -->
              <Filter 
                v-if="objParams && (dataParams && dataParams.status == true)" 
                :componentKey="this.componentKey" 
                :dataParams="dataParams" 
                :objParams="objParams" 
                @changeFilter="changeFilter" 
                @clearFilter="changeFilter('all')"  
                @changeWithClearFilter="changeWithClearFilter"
              />
              
              <!-- 
                Фільтр для таблиці, де немає пагінації та окремого запиту 
                - йде перевірка на наявність параметрів в datafilter
                - :datafilter - параметри фільтрації таблиці
                - @change - подія, яка фільтрує дані в таблиці
                - @clearFilter -  подія, для очищення фільтрів
              -->
              <FilterTable 
                v-if="this.datafilter" 
                :datafilter="datafilter"
                @change="change" 
                @clearFilter="clearFilter"  
              />
              
              <!-- Кнопка для видалення обраних записів -->
              <div 
                class="flex-shrink-0" 
                v-if="this.allSelected == true || this.checkrows != ''"
              >
                <button 
                  class="btn btn-soft-danger" 
                  v-if="this.removeitem == true" 
                  @click="this.removeAll(this.checkrows)"
                >
                  {{ this.checkrows.length }}
                  <i class="ri-delete-bin-2-line"></i>
                </button>

              </div>
            </div>
          </div>
        </b-row>

        <!-- Таби та вміст таблиці — у тій самій картці, що й панель інструментів -->
        <div class="gt-tabs-row">

          <!-- Таби по таблиці -->
          <ul
            :class="`nav nav-tabs nav-tabs-custom gt-tabs scroll-ultrathin`"
            role="tablist"
            style="width: 100%; overflow-x: auto; overflow-y: hidden; margin-top: 8px; margin-bottom: 25px;"
          >
            <!-- Таб "Всі" -->
            <li class="nav-item" >
                <a
                  :class="['nav-link', 'All', { active: activeTab === 'all' }]"
                  id="All"
                  href="#home1"
                  role="tab"
                  @click.prevent="changeFilter('all')"
                >
                  {{$t('all')}}
                </a>
            </li>

            <!-- тест нових табів -->
            <template
              v-if="verTabs == 'new'"
            >
              <template
                v-for="item in tabs"
                :key="item"
              >

                <!--
                  Таби
                  - перевірка чи увімкнений таб
                -->
                <li
                  v-if="item.settingTab.checked"
                  class="nav-item copy"
                  @contextmenu.prevent="showContextMenu($event, item)"
                >
                  <a
                    :class="['nav-link', 'color-tab', { active: activeTab === item }]"
                    role="tab"
                    @click.prevent="newChangeTab(item)"
                    aria-selected="false"
                    :style="`--tab-color: ${item.settingTab.color}`"
                  >
                    <!-- Колір таба — маркером, а не заливкою тексту (інакше кольорові всі й не виділяється жоден) -->
                    <i class="gt-tab-dot"></i>{{ item.settingTab.nameTab }}
                  </a>
                </li>

              </template>

            </template>

            <!-- Таби, які додав юзер -->
            <template
              v-if="verTabs != 'new'"
              v-for="(tab, index) in tabs"
              :key="index"
            >
              <li
                v-if="tab.checked == true"
                class="nav-item"
              >
                <a
                  :class="['nav-link', 'color-tab', { active: activeTab === tab }]"
                  :id="tab.tab"
                  :href="`#${tab.tab}`"
                  role="tab"
                  @click.prevent="changeTab(tab.obj, tab.value, tab)"
                  aria-selected="false"
                  :style="`--tab-color: ${tab.color}`"
                >
                  <!-- Колір таба — маркером, назва нейтральна -->
                  <i class="gt-tab-dot"></i>{{ tab.title }}
                </a>
              </li>
            </template>

             <!-- Кнопка для додавання/редагування табу -->
            <li v-if="addtabs && verTabs != 'new'" class="nav-item copy" >
                <a
                  :class="`nav-link gt-tab-action`"
                  @click="addCategory()"
                >
                  <i :class="tabs.length > 0 ? 'bx bx-pencil' : 'bx bx-plus'"></i>
                  {{ tabs.length > 0 ? $t('Edit') : $t('Add')}}
                </a>
            </li>

            <!-- Нова Кнопка для додавання/редагування табу -->
            <li v-if="addtabs && verTabs == 'new'" class="nav-item copy" >
                <a
                  :class="`nav-link gt-tab-action`"
                  @click="addCategory()"
                >
                  <i class="bx bx-plus"></i>
                  {{ $t('Add') }}
                </a>
            </li>
            <!-- <li class="nav-divider"></li>
            <li class="nav-item copy">
              <a 
                class="nav-link archive py-2 fs-14 text-muted" 
                data-bs-toggle="tab" 
                id="archive" 
                href="#archive" 
                role="tab"
                @click="this.$emit('getArchive')" 
              >
                Архівні
              </a>
            </li> -->
          </ul>

        <!-- Додаткові налаштування таблиці -->
        <div class="dropdown">
          <div class="btn-group">

            <!-- Виклик модального вікна на створення, в кожному розділі викликається особисте вікно -->
            <b-button
              v-if="
              this.createdform == true &&
              !(
                this.showpag 
                || (this.objParams && this.objParams.hasOwnProperty('search')) 
                || (this.objParams && this.objParams.hasOwnProperty('pr1') && this.objParams.hasOwnProperty('pr2') && this.showCalendar == true)
                || this.dataParams?.status === true
              )
            "
            @click="create"
            class="btn btn-success"
            >
            <i class="ri-add-line align-bottom"></i>
            </b-button>

            <!-- Кнопка для відкриття випадаючого списку з колонками таблиці -->
            <button class="btn btn-ghost-secondary btn-icon btn-sm fs-18" type="button" id="dropdownMenuClickableInside" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
              <i class="bx bx-table align-bottom"></i>
            </button>

            <!-- Список з вибором колонок -->
            <ul class="dropdown-menu  list-group-flush border-dashed px-3 gt-columns-menu" aria-labelledby="dropdownMenuClickableInside">
              <li class="list-group-item ps-0" v-for="item in newColumns" :key="item">
                <div class="d-flex align-items-start">
                  <!-- Форма для вибору колонки -->
                  <div class="form-check ps-0 flex-sharink-0">
                      <input type="checkbox" class="form-check-input ms-0" :id="item.name" v-model="item.status" :checked="item.status" @change="changeColumn(item)" />
                  </div>
                  <!-- Назва колонки -->
                  <div class="flex-grow-1">
                      <label class="form-check-label mb-0 ps-2" :for="item.name">{{item.name}}</label>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Таблиця з даними, якщо є рядки для відображення -->
      <div v-if="rows?.length > 0">

        <!--
          Скрол-область таблиці.
          - Горизонтальний скрол лише для самої таблиці, а не для блоку з пагінацією.
          - Варіант B: коли активний auto-height, контейнер отримує обчислену висоту (заповнює екран),
            всередині скролиться лише тіло таблиці, а шапка колонок "липне" зверху.
        -->
        <div
          class="table-responsive table-card scroll-ultrathin"
          :class="{ 'gt-autoheight': tableMaxHeight }"
          :style="tableMaxHeight ? { height: tableMaxHeight + 'px' } : null"
          ref="tableScroll"
        >

        <!--
          Таблиця для відображення даних
          - :needFixed - Фіксований розмірам. Використовується для коментів в картці клієнта, щоб не спрацювував горизонтальний скрол
        -->
        <table
          :style="newColumns[0]?.needFixed == true ? 'width: 100% !important; word-break: break-all; table-layout: fixed;' : ''"
          class="table align-middle table-nowrap mb-0 gt-table"
          id="customerTable"
          ref="table"
        >
          <!-- Заголовок таблиці -->
          <thead class="table-light text-muted">
            <tr>

              <!-- Колонка для вибору всіх рядків -->
              <th 
                v-if="this.checked == true || this.removeitem == true" 
                scope="col" 
                style="width: 40px" 
              >
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="checkAll"
                    value="option"
                    v-model="this.allSelected"
                    @click="selectAll"
                  />
                </div>
              </th>

              <!--
                Динамічні колонки
                - :newColumns - конфігурація стовпців таблиці, у кожного розділу власна конфігурація
                - position завжди 'sticky' (+ top: 0) — щоб шапка лишалась видимою під час скролу тіла.
                  Інлайн-стиль перекриває CSS, тож попереднє 'relative' скасовувало липку шапку.
                  sticky так само створює контейнер для абсолютного маркера ресайзу колонки.
                - Шари z-index: закріплена колонка тіла = 1, шапка = 2, закріплена колонка шапки = 3
              -->
              <template v-for="(column, ind) in newColumns" :key="column.id">
                <th
                  v-if="column.status == true"
                  :class="`text-left ${column.hasOwnProperty('sort') ? 'copy' : ''}`"
                  @click="column.hasOwnProperty('sort') ? sort(column, objParams.ot) : ''"
                  :style="{
                    position: 'sticky',
                    top: '0px',
                    width: column.width + 'px',
                    left: column.sticky === true ? '-1px' : '',
                    zIndex: column.sticky === true ? '3' : '2'
                  }"
                  @mousedown="startMove($event, ind)"
                  @mousemove="move($event)"
                  @mouseup="stopMove"
                  @mouseover="this.showpin[ind] = true"
                  @mouseout="this.showpin[ind] = false"
                >

                  <!-- Плавна зміна ширини колонки -->
                  <div
                    style="cursor: col-resize;right: -5px;position: absolute;top: 0;width: 10px;bottom: 0;"
                    @mousedown="startMove($event, ind)"
                    @mousemove="move($event)"
                    @mouseup="stopMove"
                  ></div>
                    <v-btn
                      text
                      block
                      x-large
                      depressed
                    >
                      <!-- Назва колонки -->
                      {{ column.name }}
                      <!-- <i 
                        v-if="column.hasOwnProperty('sort')" 
                        :class="`bx bx-${objParams.ot == 'desc' ? 'down' : (objParams.ot == 'asc' ? 'up' : 'right')}-arrow-alt`"
                      ></i> -->
                      <i
                        v-if="column.hasOwnProperty('sort') && activeSortColumn === column.sort"
                        :class="`bx bx-${objParams.ot == 'desc' ? 'down' : (objParams.ot == 'asc' ? 'up' : 'right')}-arrow-alt`"
                      ></i>
                    </v-btn>

                    <i 
                    class='bx bxs-pin' 
                    style="cursor: pointer; text-align: end; margin-left: 10px;" 
                    :style="this.showpin[ind] !== true ? 'visibility: hidden' : ''"
                    @click="stickColumn(ind)"></i>
                  </th>
              </template>
            
              <!-- Колонка дій, якщо вибрано видалення або скидання пароля -->
              <th
                v-if="removeitem || resetpass"
                style="display: none;"
                scope="col"
              >
                {{$t('action')}}
              </th>

            </tr>
          </thead>

          <!-- 
            Тіло таблиці
            - :rows - масив з даними рядків таблиці
          -->
            <tbody>

              <template  v-for="(row, index) in rows" :key="index">
              <!-- Умова для виключення конкретних рядків (для Бориса) -->
              <tr 
                @contextmenu.prevent="handleContextMenu($event, row) "
                :class="`tr_etner ${activeRow === index && this.user.userid != 36 ? 'active' : ''}`" 
                @click="setActiveRow(index)"
                v-if="(row?.userPhone !== '0637006095') && (row?.userPhone !== '0737006095') && (row?.userPhone !== '0630476445')" 
              >

              <!-- Колонка для вибору окремого рядка -->
              <th 
                v-if="this.checked == true || this.removeitem == true"
                scope="row" 
              >
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    name="checkAll"
                    v-model="checkrows"
                    @change="select(row, index)"
                    :value="row"
                  />
                </div>
              </th>

              <!-- Динамічно генеровані колонки для відображення даних -->
              <template 
                v-for="column in newColumns" 
                :key="column"
              >
                <td
                  :style="{
                    wordBreak: column?.needFixed == true ? 'auto-phrase' : '', 
                    whiteSpace: column?.needFixed == true ? 'break-spaces' : '', 
                    position: column.sticky === true ? 'sticky' : '',
                    left: column.sticky === true ? '-1px' : '', 
                    zIndex: column.sticky === true ? '1' : '',
                    backgroundColor: column.sticky === true ? 'white' : ''
                  }"
                  :class="column.align"
                  v-if="column.status == true"
                  @click="open(row)"
                >
                  
                  <template v-if="column.text != 'progressPercent'">

                    <!-- Вміст колонки з можливістю копіювання -->
                    <div
                      v-if="column.copy == true"
                      class="ctext-wrap c_block"  
                      style="display:flex"
                    >
                        <div class="ctext-wrap-content">

                          <!-- 
                            Вміст колонки 
                            - mutate - використовується для змінення данихи, наприклад переклад
                            - mutateClass - додаткові стилі
                          -->
                          <span 
                            v-html="column.mutate ? column.mutate(row[column.text], row) : row[column.text]" 
                            :class="`${column.mutateClass ? column.mutateClass(row[column.text], row) : 'none'}`"
                          ></span>

                        </div>

                        <!-- Кнопка для копіювання значення колонки -->
                        <i class="ri-file-copy-2-fill fs-14 copybtn" @click="copy(row[column.text])" ></i>
                    </div>

                    <!-- Вміст колонки без можливості копіювання -->
                     
                    <span 
                      v-else 
                      v-html="column.mutate ? column.mutate(row[column.text], row) : row[column.text]" 
                      :class="`fs-12 ${column.mutateClass ? column.mutateClass(row[column.text], row) : 'none'} ${column.mutateStyleColor ? 'badge' : ''}`"
                      :style="`background-color: ${column.mutateStyleColor ? column.mutateStyleColor(row[column.text], row) : 'none'}`"
                    ></span>
                  
                  </template>

                  <!-- Для колонки прогрес-бара -->
                  <template v-if="column.text == 'progressPercent'">
                    <div class="d-flex align-items-center">
                      <!-- Відсоток прогрес-бару -->
                      <div class="flex-shrink-0 me-1 text-muted fs-13">{{ row[column.text] }} %</div>

                      <!-- Сам прогрес-бар -->
                      <div
                          class="progress progress-sm flex-grow-1 bg-soft-primary"
                          style="width: 68%"
                      >
                        <div
                        class="progress-bar bg-primary rounded"
                        role="progressbar"
                        :style="'width: ' + row[column.text] + '%'"
                        aria-valuenow="53"
                        aria-valuemin="0"
                        aria-valuemax="100"
                        ></div>
                      </div>
                    </div>
                  </template>

                </td>
              </template>
              
              <!-- Колонка дій для видалення або скидання пароля -->
              <td v-if="removeitem || resetpass" style="display: none;">
                <ul class="list-inline hstack gap-2 mb-0">

                  <!-- Кнопка для скидання пароля -->
                  <li
                    v-if="resetpass"
                    class="list-inline-item"
                    :title="$t('reset')"
                  >
                    <button class="btn btn-soft-primary small_btn " v-if="this.resetpass == true" @click="resetpassbox(row)"><i class="ri-lock-unlock-fill"></i></button>
                  </li>

                  <!-- Кнопка для видалення -->
                  <li
                    v-if="removeitem"
                    class="list-inline-item"
                    :title="$t('Delete')"
                  >
                    <button class="btn btn-soft-danger small_btn " v-if="this.removeitem == true" @click="removeBox(row)"><i class="ri-delete-bin-2-line"></i></button>
                  </li>
                </ul>
              </td>
            </tr>
            
            <!-- Відображення дочірніх рядків -->
            <template 
              v-for="ch in row.child"  
              v-if="row.hasOwnProperty('child')"
            >
                <button 
                  type="button" 
                  class="btn btn-info waves-effect m-2 fs-12 fw-semibold" 
                  v-html="ch.terminalName" 
                  @click="$emit('openTerminal', ch)"
                ></button>
            </template>

          </template>

          </tbody>
      </table>
        </div>

          <!--
            Футер таблиці (варіант A): кількість рядків + номери сторінок ліворуч,
            підсумок притиснутий праворуч. Один рядок замість двох поверхів —
            звільняє ~65px під рядки таблиці.
          -->
          <div class="gt-footer">

            <!-- Вибір кількості елементів на сторінці -->
            <div class="pagination-wrap hstack gap-2" v-if="this.showpag">
              <select class="form-select mb-0" v-model="limit" @change="changelimit(limit)">
                <option v-for="item in limits" :key="item" :value="item.value" >{{item.value}}</option>
              </select>
            </div>

            <!-- Відображення номерів сторінок -->
            <div class="pagination-wrap hstack gap-2" v-if="this.showpag">
              <ul class="pagination listjs-pagination mb-0">
                <li v-for="(pageNumber, index) in this.pages.links" :key="index"
                  :class="pageNumber.current == 'true' ? 'active' : null"
                  @click="getdata(pageNumber.page)"
                >
                  <button class="page">{{ pageNumber.page }}</button>
                </li>
              </ul>
            </div>

            <!-- Підсумок по кількості записів -->
            <div class="gt-footer-total">
              <b>{{ $t('Total') }} : </b>{{rows.length}}
              <span v-if="this.showpag">{{ $t('outOf') }} {{ this.pages.total ? this.pages.total : this.pagesr }}</span>
            </div>

          </div>
        </div>

        <!-- Відображення повідомлення про відсутність результатів -->
        <div v-else class="noresult" style="display: block;">

          <div class="text-center" v-if="checks['024'] == false">
            <h5 class="mt-2">{{ $t('SorryNoResultFound') }}</h5>
            <p class="text-muted mb-0">{{ $t('WeveSearchedMoreThan2') }}</p>
          </div>
          <div class="text-center" v-else>
            <h5 class="mt-2">{{ $t('pashNotFound') }}</h5>
            <p class="text-muted mb-0">{{ $t('pashNotFoundDesc') }}</p>
          </div>

        </div>
      </b-card>
    </b-col>
  </b-row>
  

  <!-- Модальне вікно для підтвердження видалення -->
  <dialodel 
    v-if="dialogshow" 
    @close="dialogshow = false" 
    :obj="item" 
    @remove="remove" 
  />

  <!-- Модальне вікно для підтвердження скидання пароля -->
  <dialogresetpass 
    v-if="dialogresetshow" 
    @close="dialogresetshow = false" 
    :obj="item" 
    @resetPass="resetPass" 
  />

  <!-- Контекстне меню для табів -->
  <my-context-menu 
    ref="contextMenu" 
    :btn="btnContextMenu"
    @select="switchCntMenu"
  />

</template>

<script>
import {getMonth} from '@/usabilityScripts/globalMutate.js'
import Filter from "./globalFilter.vue"; // Фільтр по таблиці з запитом
import FilterTable from "./frontFilter"; // Фільтр для таблиці, де немає пагінації та окремого запиту 
import searchBox from "./searchbox.vue";
import dialodel from './actions/dialogdelete'
import dialogresetpass from './actions/dialogresetpass'
import preloaderTable from './preloader'
import filterDateTime from '../calendar'
import { storeS } from '@/store.js'
import MyContextMenu from '@/components/contextMenu/index.vue'; // компонент контекст-меню
import {copy} from '@/usabilityScripts/copy.js'

export default {
  /*
    Про пропси - 
    - checked: Булеве значення, що вказує, чи включено виділення рядків.
    - checkedItems: Масив, що містить виділені рядки.
    - datafilter: Об'єкт, що містить фільтри для таблиці.
    - objParams: Параметри таблиці.
    - dataParams: Додаткові параметри таблиці.
    - tabs: Масив табів таблиці.
    - rows: Масив рядків для відображення в таблиці.
    - newColumns: Масив колонок таблиці.
    - createdform: Об'єкт, що містить дані про створення форми.
    - removeitem: Булеве значення, яке вказує, чи включена опція видалення рядків.
    - resetpass: Булеве значення, яке вказує, чи включена опція скидання паролю.
    - addtabs: Булеве значення, яке вказує, чи включена опція додавання закладок.
    - typesearch: Тип пошуку в таблиці.
    - showpag: Булеве значення, яке вказує, чи відображається пагінація.
    - pages: Інформація про сторінки для пагінації.
    - showContxtMenu: Булеве значення, яке вказує, чи відображати контекстне меню.
    - activeSortColumn: Активна колонка сортуванняб
    - verTabs: версія нового коду для табів (тимчасово)
    - objFilter: відображення кнопок перемикання таблиця/грід
  */
  props:[ 
    'checked', 
    'checkedItems', 
    'datafilter', 
    'objParams', 
    'dataParams', 
    'tabs', 
    'rows', 
    'columns', 
    'createdform', 
    'removeitem', 
    'resetpass', 
    'addtabs', 
    'typesearch', 
    'showpag',
    'pages',
    'showContxtMenu',
    'activeSortColumn',
    'verTabs',
    'objFilter'
  ],
  data() {
    return {
      tableMaxHeight: null, // Варіант B: обчислена висота скрол-області таблиці (null = природна висота)
      newColumns: [],
      showpin: [],
      showCalendar: '', // Прапорець, що вказує, чи відображається календар
      searchTime: '', // Ідентифікатор таймера для затримки пошуку
      search: "", // Рядок для пошуку в таблиці.
      selected: [], // Масив виділених рядків
      allSelected: false, // Булеве значення, що вказує, чи обрані всі рядки.
      dialogshow: false, // Прапорець на відображення вікна видалення
      dialogresetshow: false, // Прапорець на відображення вікна скидання паролю.
      dialocopyshow: false,// Прапорець на відображення вікна копіювання
      checkrows: [], // Масив для зберігання виділених рядків.
      item: "", // Об'єкт для зберігання інформації про рядок.
      page: 1, // Номер поточної сторінки.
      perPage: 5, // Кількість елементів на сторінці.
      limit: "", // Рядок, що вказує обрану кількість елементів на сторінці.
      date: '', // Об'єкт, що містить інформацію про вибрану дату.
      limits: [ // Масив об'єктів, що містять варіанти кількості елементів на сторінці.
        { value: '5'},
        { value: '10'},
        { value: '25'},
        { value: '50'},
        { value: '75'},
        { value: '100'},
        { value: this.$t('all')},
      ],
      typeList: null, // 0 - grid, 1 - list,
      activeTab: 'all', // Активний таб-фільтр (єдине джерело правди для підсвітки): 'all' = таб "Всі", інакше — посилання на об'єкт таба з масиву tabs
      draggable: false, // Булеве значення, що вказує, чи можна переміщати колонки.
      startOffset: 0, // Значення зсуву для початку переміщення колонки.
      selectedCol: null, // Індекс обраної колонки для переміщення
      activeRow: null,
      btnContextMenu: [ // Параметри для контекстного меню
        { 
          // Редагувати таб
          title: this.$t('toEditAp'),
          icon: 'ri-pencil-fill',
          color: 'secondary',
          value: 'edit',
          status: true,
          perms: null
        },
        { 
          // Видалити таб
          title: this.$t('Delete'),
          icon: 'ri-delete-bin-line',
          color: 'danger',
          value: 'delete',
          status: true,
          perms: null
        }
      ]
    }
  },
  components: {
    Filter,
    FilterTable,
    searchBox,
    dialodel,
    dialogresetpass,
    preloaderTable,
    filterDateTime,
    MyContextMenu
  },
  created(){

    // Селект показує збережений вибір, якщо він є, інакше — значення від батьківського списку
    var savedLimit = this.readSavedPagelimit();
    this.limit = savedLimit
      ? savedLimit
      : (this.objParams?.pagelimit ? this.objParams.pagelimit : (this.objParams?.pageLimit ? this.objParams?.pageLimit : '25'))
    
    // Якщо фільтр за датою не застосований - показуємо "За весь час", інакше поточну дату
    if(this.objParams && 'pr1' in this.objParams && !this.objParams.pr1) {
      this.date = {
        title: this.$t('ForallTime'),
        value: ''
      }
    } else {
      this.date = {
        title: this.currentDate().day + ' ' + this.$t(`${this.currentDate().month}`) + ', ' +this.currentDate().year,
        value: this.currentDate().year + '-' + new Date().getMonth() + this.currentDate().day,
        month: this.currentDate().monthNum
      }
    }

    if(this.checkedItems || this.checkedItems != undefined){
      this.getChecked()
    }

    // Заповнюємо масив відповідностей індексів для іконок
    this.columns.forEach((el, index) => {
      this.showpin[index] = false
      this.columns[index]['sticky'] = false
    })

    if (this.objFilter && this.objFilter.defaultType) {
      this.typeList = this.objFilter.defaultType ? this.objFilter.defaultType : 1
    }

  },
  methods: {
    updateTableHeight(pass = 0) {
      // Варіант B — таблиця на всю висоту екрана: рахуємо висоту скрол-області так,
      // щоб низ картки опинявся біля низу вьюпорта (без скролу сторінки), а всередині
      // скролилося лише тіло таблиці. Вимір робимо від реального "підвалу" картки,
      // тож працює за будь-якої структури над таблицею (PageHeader, картка фільтрів тощо).
      // nextTick + rAF => вимірюємо ПІСЛЯ того, як браузер зробив лейаут з новими даними,
      // інакше при зміні кількості рядків (напр. фільтр 25 -> 19) можна прочитати застарілу висоту.
      this.$nextTick(() => {
        // Компонент міг розмонтуватись, поки чекали на nextTick (перехід на іншу сторінку,
        // відкриття модалки). Зміна реактивних даних на розмонтованому інстансі ламає
        // планувальник Vue (помилки виду "emitsOptions of null" / "_assign of null").
        if (this._gtDestroyed) return;

        this._gtRaf = requestAnimationFrame(() => {
          this._gtRaf = null;
          if (this._gtDestroyed) return;

          const scroll = this.$refs.tableScroll;

          // Застосовуємо лише для повноцінних списків з пагінацією.
          if (this.showpag !== true || !scroll) {
            this.tableMaxHeight = null;
            return;
          }

          // Не чіпаємо таблиці всередині модалок / офф-канвасу — там висота має бути природною.
          if (scroll.closest('.modal, .modal-dialog, .modal-content, .offcanvas')) {
            this.tableMaxHeight = null;
            return;
          }

          if (typeof ResizeObserver !== 'undefined') {
            // Перерахунок при зміні розмірів верхніх блоків (фільтри, календар, ресайз вікна).
            if (!this._gtResizeObserver) {
              const host = scroll.closest('.page-content') || document.body;
              this._gtResizeObserver = new ResizeObserver(() => {
                if (!this._gtDestroyed) this.updateTableHeight();
              });
              this._gtResizeObserver.observe(host);
            }
            // Перерахунок саме тоді, коли сама таблиця змінила висоту (додались/зникли рядки).
            // Таблиця не обмежена по висоті, тож наші зміни висоти контейнера її не тригерять — циклу немає.
            const table = this.$refs.table;
            if (table && this._gtObservedTable !== table) {
              if (this._gtTableObserver) this._gtTableObserver.disconnect();
              this._gtTableObserver = new ResizeObserver(() => {
                if (!this._gtDestroyed) this.updateTableHeight();
              });
              this._gtTableObserver.observe(table);
              this._gtObservedTable = table;
            }
          }

          const scrollRect = scroll.getBoundingClientRect();
          const card = scroll.closest('.card');

          // Скільки місця займає все, що нижче скрол-області в межах картки
          // (блок "Всього" + пагінація + внутрішні відступи + margin картки).
          let below = 40; // запасний варіант, якщо картку не знайдено
          if (card) {
            const cardRect = card.getBoundingClientRect();
            const cardMb = parseFloat(getComputedStyle(card).marginBottom) || 0;
            below = (cardRect.bottom - scrollRect.bottom) + cardMb;
          }

          // Рахуємо в системі координат контейнера, що реально скролиться (у цьому додатку
          // — .main-content), а не вьюпорта. Усі три величини читаються в одному кадрі, тож
          // результат не залежить від поточної прокрутки:
          //   offsetInScroller — відступ таблиці від початку контенту скролера,
          //   viewportH        — видима висота скролера.
          // Мішати scrollTop із window.innerHeight не можна: це різні системи координат, і після
          // згортання блоків (напр. статистики) застарілий scrollTop давав завищений top,
          // через що таблиця лишалась коротшою за екран.
          const scroller = scroll.closest('.main-content');
          let offsetInScroller;
          let viewportH;

          if (scroller) {
            const scrollerRect = scroller.getBoundingClientRect();
            offsetInScroller = (scrollRect.top - scrollerRect.top) + scroller.scrollTop;
            viewportH = scroller.clientHeight;
          } else {
            offsetInScroller = scrollRect.top + (window.scrollY || document.documentElement.scrollTop || 0);
            viewportH = window.innerHeight;
          }

          const BOTTOM_GAP = 14; // нижній padding .page-content + невеликий запас
          const available = viewportH - offsetInScroller - below - BOTTOM_GAP;

          // Природна висота контенту в скрол-області (scrollHeight не залежить від виставленої висоти
          // контейнера, тож коректний і коли height вже застосований).
          const contentH = scroll.scrollHeight;

          // Розтягуємо на висоту екрана лише коли:
          //  - місця достатньо (не вузький/вбудований контейнер), і
          //  - рядки реально не вміщаються (+2px допуск проти "тремтіння" на межі).
          // Коли рядків мало — лишаємо природну висоту, щоб пагінація була одразу під рядками,
          // а не прибита до низу сторінки.
          const next = (available > 220 && contentH > available + 2) ? Math.floor(available) : null;
          if (this.tableMaxHeight !== next) {
            this.tableMaxHeight = next;
            // Доводочний прохід: після зміни висоти браузер може перерахувати/обрізати прокрутку
            // (напр. коли контент перестав переповнювати сторінку). Перевіряємо результат ще раз,
            // інакше таблиця може залишитись коротшою за екран. Обмежено, щоб не зациклитись.
            if (pass < 2) {
              this._gtSettleRaf = requestAnimationFrame(() => {
                this._gtSettleRaf = null;
                if (this._gtDestroyed) return;
                this.updateTableHeight(pass + 1);
              });
            }
          }
        });
      });
    },
    showContextMenu(event, item) {
      // Метод, який викликається при правому кліку на елементі, передаючи подію та об'єкт item
      console.log("showContextMenu");
      

      // Викликаємо метод показу контекстного меню після оновлення DOM
      this.$nextTick(() => {
          // Виклик методу показу контекстного меню у компоненті contextMenu,
          // передаючи подію та об'єкт item
          this.$refs.contextMenu.showContextMenu(event, item);
      });
    },
    switchCntMenu(e, item){
        // Виконуємо обрану дію з контекстного меню

        switch (e) {
            case 'edit':
                // Редагуємо таб
                this.$emit('editTab', item)
                break;
            case 'delete':
                // Видалити таб
                this.$emit('removeTab', item)
                break;
            
            default:
                break;
        }
    },
    stickColumn(ind) {
      console.log(ind, this.newColumns)
      
      // Перший елемент масиву поміщаємо в запасну змінну
      let zero = this.newColumns[0]
      
      // Змінюємо перший елемент масиву
      this.newColumns[0] = this.newColumns[ind]
      this.newColumns[0].sticky = true
      
      // Змінюємо елемент масиву, що в минулому був на тому місці
      this.newColumns[ind] = zero
      this.newColumns[ind].sticky = false

      console.log(ind, this.newColumns)
    },
    currentDate() {
      // Повертає об'єкт з інформацією про поточну дату

      var date = new Date();
      var dateStr = {
          day: ("00" + (date.getDate())).slice(-2),
          month: (this.month(date.getMonth() + 1)),
          year: date.getFullYear(),
          monthNum: date.getMonth()
      }
      return dateStr
    },
    month(e) {
      // Повертає назву місяця за його номером
      return getMonth(e)
    },
    open: function(e){
      // Відкриваємо вікно картки з розділу виклику
      this.$emit("open", e);
    },
    setActiveRow(index) {
      // Додаємо клас active до обраної строки (яку відкрили)
      this.activeRow = index;
    },
    changeColumn(e){
      if(this.dataParams?.page){
        localStorage.setItem(this.dataParams.page + " " + String(this.dataParams.status), JSON.stringify(this.columns))
      }
      // Змінюємо відображення колонки
      this.$emit('changeColumn', e)
    },
    getChecked(){
      // Заповнює масив виділених рядків при старті компонента
      for(var item in this.checkedItems){
        this.checkrows.push(this.checkedItems[item])
      }
    },
    move(e) {
      // Обробник події переміщення колонки
      if (this.draggable) {
        let newWidth = this.startOffset + e.pageX;
        let colObj = this.columns[this.selectedCol];
        colObj.width = newWidth;
      }
    },
    startMove(e, ind) {
      // Обробник події початку переміщення колонки
      this.draggable = true;
      this.startOffset = this.columns[ind].width - e.pageX;
      this.selectedCol = ind;
    },
    stopMove() {
      // Обробник події закінчення переміщення колонки
      this.draggable = false;
    },
    create(){
      // Викликаємо вікно створення
      this.$emit('create')
    },
    searchB(e){
      // Обробник події пошуку з затримкою

      clearTimeout(this.searchTime)
      this.search = e
      this.searchTime = setTimeout(() => this.$emit('search', e), 500)
    },
    changeWithClearFilter(name, value) {
      this.$emit('changeWithClearFilter', name, value)
    },
    changeFilter(nameFilter, filterChange){
      //для зміни фільтрації

      if(nameFilter == 'pr') {
        // Перевірити що filterChange це масив з 2 датами
        if(!Array.isArray(filterChange) || filterChange.length < 2) {
          return
        }

        // Обидві дати пусті - скидання фільтру за датою ("За весь час")
        if(!filterChange[0] && !filterChange[1]) {
          this.date = {
            title: this.$t('ForallTime'),
            value: ''
          }
          this.$emit('changeFilter', 'pr', ['', ''])
          return
        }

        if(filterChange[0] === '' || filterChange[1] === '') {
          return
        }

        if(filterChange[0] == filterChange[1]) {
          this.date = {
            title: this.date = filterChange[0].split('-')[2] + ' ' + this.$t(this.month(filterChange[0].split('-')[1])) + ' ' + filterChange[0].split('-')[0],
            value: this.date = filterChange[0].split('-')[2] + ' ' + filterChange[0].split('-')[1] + ' ' + filterChange[0].split('-')[0]
          }
        } else {
          this.date = {
            title: filterChange[0].split('-')[2] + ' ' + this.$t(this.month(filterChange[0].split('-')[1])) + ' ' + filterChange[0].split('-')[0] + ' - ' + filterChange[1].split('-')[2] + ' ' + this.$t(this.month(filterChange[1].split('-')[1])) + ' ' + filterChange[1].split('-')[0],
            value: filterChange[0].split('-')[2] + ' ' + filterChange[0].split('-')[1] + ' ' + filterChange[0].split('-')[0] + ' - ' + filterChange[1].split('-')[2] + ' ' + filterChange[1].split('-')[1] + ' ' + filterChange[1].split('-')[0]
          }
        }
      }

      // Активним робимо таб "Всі" лише коли явно обрано 'all' (клік по табу "Всі"
      // або скидання фільтрів). Дропдаун-фільтри й дати активний таб не змінюють.
      if(nameFilter === 'all') {
        this.activeTab = 'all'
        this.scrollTableToTop(); // клік по табу "Всі" — показуємо початок списку
      }
      this.$emit('changeFilter', nameFilter, filterChange)
    },
    changeTab(nameFilter, filterChange, tab){
      // Зміна активної вкладки/табу.
      // Ідентифікуємо активний таб за посиланням на об'єкт (а не за tab.tab чи index):
      // поле tab.tab може дублюватися (напр. saveMulti() хардкодить 'tab1'), тож лише
      // посилання на об'єкт гарантує унікальність і коректну підсвітку рівно одного табу.
      this.eventBus.emit('refreshFilters', {})
      this.activeTab = tab
      this.scrollTableToTop(); // інший таб — показуємо початок списку
      this.$emit('changeTab', nameFilter, filterChange)
    },
    newChangeTab(item){
      // Нова зміна активного табу
      this.eventBus.emit('refreshFilters', {})
      this.activeTab = item
      this.scrollTableToTop(); // інший таб — показуємо початок списку
      this.$emit('changeTabNew', item)
    },
    // change(name, e){
    //   // Фільтрує дані в таблиці 
    //   this.$emit('change', name, e)
    // },
    addCategory(){
      // Відкриваємо вікно створення табу на сторінці виклику
      this.$emit('addCategory')
    },
    getdata(e){
      // отримання даних по таблиці
      this.scrollTableToTop(); // нова сторінка — показуємо її початок, а не попередню позицію скролу
      this.$emit('getdata', e)
    },
    scrollTableToTop(){
      // Скидання внутрішнього скролу таблиці на початок.
      // Без цього після зміни сторінки/кількості рядків користувач лишається
      // в середині списку й бачить не перші записи нової сторінки.
      var scroll = this.$refs.tableScroll;
      if (scroll && scroll.scrollTop) {
        scroll.scrollTop = 0;
      }
    },
    selectAll: function() {
      // Вибирає всі рядки в таблиці.
      this.checkrows = [];
      if (this.allSelected == false) {
          for (var item in this.rows) {
              this.checkrows.push(this.rows[item]);
          }
      }
      this.$emit('check', this.checkrows)
    },
    select(checked, item) {
      // Обробник події вибору рядка
      this.allSelected = false;
      this.$emit('check', this.checkrows)
    },
    removeAll(e){
      // Видалення всіх даних
      this.$emit("removeAll", e);
    },
    // remove(e){
    //   // Видалення даних по рядку

    //   e.status = "Removed"
    //   this.$emit("remove", e, e);
    //   this.dialogshow = false
    // },
    removeBox(e){
      // Відображає діалог видалення для конкретного рядка.
      this.item = e;
      this.dialogshow = true
    },
    // resetPass(e){
    //   // Скидання паролю

    //   this.$emit("resetPass", e);
    //   this.dialogresetshow = false;
    // },
    resetpassbox(e){
      // Відображає діалог скидання паролю для конкретного рядка

      this.item = e;
      this.dialogresetshow = true;
    },
    copy(item){
      // копіювання
      if(copy(item) == true) {
          this.$toast.success(this.$t('Copied'));
      } else {
          this.$toast.error(`Fucking mistake, contact Borys`);
      }
      return
    },
    changelimit(limit){
      // Подія для зміни кількості елементів на сторінці

      this.scrollTableToTop(); // інша кількість рядків — теж показуємо початок списку

      var newLimit = ''
      if(this.pages && limit == this.$t('all')){
        newLimit = this.pages.total
      } else {
        newLimit = limit;
        // Запам'ятовуємо вибір користувача. Варіант "всі" НЕ зберігаємо: його значення
        // залежить від локалі та від поточного розміру вибірки.
        this.savePagelimit(newLimit);
      }

      this.$emit('changelimit', newLimit)
    },
    savePagelimit(value){
      // Єдине місце збереження кількості рядків: глобальний стор (для в'ю, що читають
      // storeS.pagelimit) + localStorage, щоб вибір переживав перезавантаження сторінки.
      storeS.pagelimit = String(value);
      try {
        localStorage.setItem('pagelimit', String(value));
      } catch (e) {
        // приватний режим / переповнене сховище — не критично
      }
    },
    readSavedPagelimit(){
      // Збережена кількість рядків (стор має пріоритет, localStorage — на випадок,
      // якщо стор ще не гідратований)
      if(storeS.pagelimit) return String(storeS.pagelimit);
      try {
        return localStorage.getItem('pagelimit');
      } catch (e) {
        return null;
      }
    },
    sort(e, ot){
      console.log(...arguments)
      this.$emit('sortColumn', e, ot)
    },
    handleContextMenu(event, row) {
      // Викликаємо метод показу контекстного меню після оновлення DOM
      this.$nextTick(() => {
        this.$emit('showMenu', event, row);
        
      });
    },
    handleClickOutside(event) {
      // Прибираємо клас active, якщо натиснути поза межами таблиці

      // Отримати елемент, на який клікнули
      const targetElement = event.target;
      // Отримати елемент таблиці
      const tableElement = this.$refs.table;

      if (event.target.closest('.modal')) {
        return; // Ігноруємо кліки всередині модального вікна
      }

      if (!tableElement?.contains(targetElement)) {
        // Якщо так, обнулити activeRow
        this.activeRow = null;
      }
    }
  },
  mounted(){

    // Додаємо обробник події кліків при монтажі компонента
    document.addEventListener('click', this.handleClickOutside);

    document.addEventListener('mouseup', this.stopMove);
    document.addEventListener('mousemove', this.move);

    // Варіант B: розрахунок висоти таблиці під висоту екрана + перерахунок при ресайзі вікна
    this._gtDestroyed = false;
    this._gtResizeHandler = () => {
      if (!this._gtDestroyed) this.updateTableHeight();
    };
    window.addEventListener('resize', this._gtResizeHandler);
    this.updateTableHeight();

    // Страхувальна гілка. Основну роботу робить глобальний міксин
    // (src/mixins/pagelimit.js): він підставляє збережений ліміт в objParams ще до
    // першого запиту в'ю. Сюди доходять лише випадки, які міксин не покриває
    // (напр. батько тримає параметри в полі з іншою назвою) — там ліміт
    // виправляємо вже після старту, тому летить додатковий запит.
    var savedLimit = this.readSavedPagelimit();
    if (
      this.showpag === true &&
      savedLimit &&
      this.objParams &&
      this.objParams.pagelimit !== undefined &&
      String(this.objParams.pagelimit) !== String(savedLimit)
    ) {
      this.$emit('changelimit', savedLimit);
    }

    if(this.dataParams?.page){
      this.newColumns = this.columns
      setTimeout(() => {
          let arr = JSON.parse(localStorage.getItem(this.dataParams.page + " " + String(this.dataParams.status)))
          if(Array.isArray(arr)) {
            arr.forEach(el => {
              this.newColumns[this.columns.indexOf(this.columns.find(k => el.name == k.name))].status = el.status
            })
          }
      }, 2000) //костиль з таймером, щоб встигнути підтягнути дані з localStorage
    } else {
      this.newColumns = this.columns
    }
  },
  beforeDestroy() {
    // Видаляємо обробник події кліків перед знищенням компонента
    document.removeEventListener('click', this.handleClickOutside);
  },
  beforeMount() {
    document.removeEventListener('mouseup', this.stopMove); document.removeEventListener('mousemove', this.stopMove);
  },
  beforeUnmount() {
    // Прибираємо слухачі Варіанта B (у Vue 3 працює саме beforeUnmount, а не beforeDestroy).
    // Прапорець + скасування rAF: інакше відкладені колбеки спрацюють уже після розмонтування
    // і спробують змінити реактивні дані мертвого інстансу (помилки в планувальнику Vue).
    this._gtDestroyed = true;
    if (this._gtRaf) {
      cancelAnimationFrame(this._gtRaf);
      this._gtRaf = null;
    }
    if (this._gtSettleRaf) {
      cancelAnimationFrame(this._gtSettleRaf);
      this._gtSettleRaf = null;
    }
    if (this._gtResizeHandler) {
      window.removeEventListener('resize', this._gtResizeHandler);
    }
    if (this._gtResizeObserver) {
      this._gtResizeObserver.disconnect();
      this._gtResizeObserver = null;
    }
    if (this._gtTableObserver) {
      this._gtTableObserver.disconnect();
      this._gtTableObserver = null;
      this._gtObservedTable = null;
    }
  },
  watch: {
    // Дані змінилися (нова сторінка/фільтр/ліміт) — перерахувати висоту таблиці
    rows() {
      this.updateTableHeight();
    },
    // Батьківський список змінив кількість рядків (напр. скидання фільтрів/перемикання таба) —
    // тримаємо селект синхронним, щоб він не показував одне, а запит слав інше
    'objParams.pagelimit'(value) {
      if (value === undefined || value === null) return;
      // Вибір "всі" не чіпаємо: там у батька лежить обчислене число, а в селекті — слово
      if (this.limit === this.$t('all')) return;
      if (String(value) !== String(this.limit)) {
        this.limit = String(value);
      }
    }
  },
  computed: {
    user(){
      /*
        Повертає дані користувача з глобального стору.
      */
      return storeS.userbase
    },
    perms(){
      /*
        Повертає дані прав доступу користувача з глобального стору.
      */
      return storeS.perms
    },
    checks(){
      /*
        Повертає дані налаштувань користувача з глобального стору.
      */
      return storeS.checks
    },
    preloaderTable(){
      /*
        Повертає статус лоадера
      */
      return storeS.preloaderTable
    }
  }
}
</script>

<style>
/* <style scoped> */
.tr_etner {
  cursor: pointer;
  transition: background-color 0.15s ease;
}
.tr_etner:hover {
  background: rgba(59, 125, 221, 0.06);
}
.tr_etner.active {
  background: rgba(59, 125, 221, 0.12);
  transition: .3s;
}
.small_btn {
  max-width: 48px;
  max-height: 30px;
  padding: 0.3rem 1.0rem;
}

/* Dark theme table row styles */
[data-layout-mode="dark"] .tr_etner:hover {
  background: rgba(10, 179, 156, 0.12);
}
[data-layout-mode="dark"] .tr_etner.active {
  background: rgba(10, 179, 156, 0.18);
}

[data-layout-mode="dark"] td.left {
  font-weight: 600;
}

.cross-btn {
  display: none
}

a.nav-link:hover .cross-btn {
  display: inline-block
}

.copybtn {
    cursor: pointer;
    margin-top: -3px;
    margin-left: 5px;
    opacity: 0;
    transition: opacity .3s;
}
.c_block:hover .copybtn {
    opacity: 1;
    transition: opacity .3s;
}

.table-nowrap td, .table-nowrap th {
  white-space: inherit;
  padding: 12px 16px;
}
th.text-left {
  border-left: 1px solid rgba(116, 116, 116, 0.15);
  border-right: 1px solid rgba(116, 116, 116, 0.15);
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--vz-secondary-color);
}

[data-layout-mode="dark"] th.text-left {
  border-color: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.6);
}

.mainCalendarButton{
    height: 40px;
    border: none;
    border-radius: 6px;
    background-color: var(--vz-light);
    border: 1px solid var(--vz-border-color);
    font-size: 13px;
    font-weight: 500;
    line-height: 1.5;
    width: 200px;
    transition: all 0.15s ease;
}
.mainCalendarButton:hover {
    background-color: var(--vz-tertiary-bg);
}
[data-layout-mode="dark"] .mainCalendarButton {
  background-color: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.1);
  color: #ced4da;
}
[data-layout-mode="dark"] .mainCalendarButton:hover {
  background-color: rgba(255, 255, 255, 0.08);
}
[data-layout-mode="dark"] #All{
  color: #ced4da !important
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* Окремий перехід для календаря - коротший, щоб дропдаун відкривався одразу */
.calendarFade-enter-active,
.calendarFade-leave-active {
  transition: opacity 0.12s ease;
}

.calendarFade-enter-from,
.calendarFade-leave-to {
  opacity: 0;
}
.nav-divider {
  width: 1px;
  background-color: #ccc;
  margin: 0 10px;
  height: 20px;
  align-self: center;
}

/* Покращений вигляд таблиці */
.table-card {
  border-radius: 8px;
  overflow: hidden;
}

/*
  Варіант B — таблиця на всю висоту екрана.
  Активується класом .gt-autoheight (лише списки з пагінацією поза модалками).
  Три класи дають вищу специфічність за .table-card, тож overflow:auto перекриває overflow:hidden.
*/
.table-responsive.table-card.gt-autoheight {
  overflow: auto;
}
/* Вигляд скролбара — глобальний (assets/scss/structure/_scrollbars.scss) */
/* Липка шапка колонок: не зникає під час скролу тіла таблиці */
.table-responsive.table-card.gt-autoheight thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  /* Непрозорий фон, щоб рядки не просвічували під шапкою при скролі */
  background-color: var(--vz-card-bg, var(--vz-secondary-bg, #fff));
}

/*
  Компактніший вигляд списків — щоб у видиму область вміщалося більше рядків.
*/
/*
  Таби списку (варіант A): нейтральний текст + кольорова крапка-маркер.
  Раніше колір таба заливав ТЕКСТ (_nav.scss: .color-tab { color: var(--tab-color) }),
  тож кольоровими були всі таби одразу — активний губився серед них.
  Селектори навмисно довгі: мають перекрити базові правила .nav-tabs-custom,
  зокрема варіанти для темної теми. Усе скоуплено класом .gt-tabs, щоб інші
  .nav-tabs-custom у застосунку лишились без змін.
*/
/* Скролбар смуги табів — глобальний, у найтоншому варіанті (.scroll-ultrathin у шаблоні) */
.gt-tabs.nav-tabs-custom {
  /* !important + background-color (не скорочення): правило [data-layout-mode=dark] .nav-tabs-custom
     має таку саму специфічність і перекривало підкладку смуги табів */
  border: none !important;
  background-color: transparent !important;
  padding: 0;
  gap: 2px;
  width: 100% !important;
  align-items: center;
}
.gt-tabs.nav-tabs-custom .nav-item .nav-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 500;
  border-radius: 7px;
  white-space: nowrap;
}
/*
  Колір користувача більше не фарбує текст — лише крапку-маркер.
  !important тут свідомо: базові правила .color-tab мають окремі варіанти для темної теми,
  і без нього кольоровий текст подекуди «пробивався».
*/
.gt-tabs.nav-tabs-custom .nav-item .nav-link,
.gt-tabs.nav-tabs-custom .nav-item .nav-link.color-tab {
  color: var(--vz-secondary-color) !important;
  background-color: transparent !important;
  box-shadow: none !important;
}
.gt-tabs.nav-tabs-custom .nav-item .nav-link:hover,
.gt-tabs.nav-tabs-custom .nav-item .nav-link.color-tab:hover {
  color: var(--vz-body-color) !important;
  /* Слабший за активний, але помітний — з тієї ж причини не використовуємо --vz-tertiary-bg */
  background-color: rgba(0, 0, 0, 0.04) !important;
}
[data-layout-mode="dark"] .gt-tabs.nav-tabs-custom .nav-item .nav-link:hover,
[data-layout-mode="dark"] .gt-tabs.nav-tabs-custom .nav-item .nav-link.color-tab:hover {
  background-color: rgba(255, 255, 255, 0.06) !important;
}
/* Активний стан — однаковий для "Всі" й кольорових табів, тож завжди очевидний */
/*
  Активний таб виділяємо лише заливкою та яскравішим текстом.
  Вагу шрифту НЕ міняємо: жирніший текст ширший, тож сусідні таби зсувались
  щоразу при перемиканні (смуга «стрибала»).
*/
.gt-tabs.nav-tabs-custom .nav-item .nav-link.active,
.gt-tabs.nav-tabs-custom .nav-item .nav-link.color-tab.active {
  color: var(--vz-body-color) !important;
  /* Не --vz-tertiary-bg: у темній темі він майже зливається з фоном картки і заливки не видно */
  background-color: rgba(0, 0, 0, 0.07) !important;
  font-weight: 500;
}
[data-layout-mode="dark"] .gt-tabs.nav-tabs-custom .nav-item .nav-link.active,
[data-layout-mode="dark"] .gt-tabs.nav-tabs-custom .nav-item .nav-link.color-tab.active {
  background-color: rgba(255, 255, 255, 0.11) !important;
}
/* Маркер кольору таба */
.gt-tab-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex: 0 0 auto;
  background-color: var(--tab-color, var(--vz-secondary-color));
}
/*
  "Змінити/Додати" — це дія, а не фільтр. Відділяємо відступом, але робимо
  органічним із табами: той самий розмір/вага шрифту, іконка та легка рамка-чіп
  з акцентним кольором, щоб було зрозуміло що це клікабельна дія.
*/
.gt-tabs.nav-tabs-custom .nav-item .nav-link.gt-tab-action {
  margin-left: 10px;
  /*
    ul має overflow-y:hidden (для горизонтального скролу табів), тож рамка чіпа
    не повинна виходити за висоту звичайних табів — інакше нижній край обрізає.
    Компенсуємо 1px рамки зверху/знизу меншим паддингом (7px замість 8px),
    щоб повна висота коробки дорівнювала текстовим табам.
  */
  padding-top: 7px;
  padding-bottom: 7px;
  margin-bottom: 0 !important;
  /* розмір/вага успадковуються від .nav-link (13px / 500) — як у табів */
  gap: 5px;
  color: #0ab39c !important;
  border: 1px solid rgba(10, 179, 156, 0.35) !important;
  background-color: rgba(10, 179, 156, 0.08) !important;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}
.gt-tabs.nav-tabs-custom .nav-item .nav-link.gt-tab-action i {
  font-size: 15px;
  line-height: 1;
}
.gt-tabs.nav-tabs-custom .nav-item .nav-link.gt-tab-action:hover {
  color: #0ab39c !important;
  border-color: rgba(10, 179, 156, 0.6) !important;
  background-color: rgba(10, 179, 156, 0.16) !important;
}

/*
  Рядок "таби + кнопка налаштування колонок".

  Кнопка сиділа зверху, бо за замовчуванням у flex діє align-items: stretch,
  а у ul з табами ще й несиметричні вертикальні margin (8px зверху / 25px знизу).

  Центрувати кнопку по коробці ul (align-items: center) не можна: на вузьких
  екранах у ul з'являється горизонтальний скролбар табів, він додає ~11px до її
  висоти — і кнопка з'їжджала вниз рівно там, де скрол виникав.

  Тому вирівнюємо по ВЕРХУ рядка й задаємо кнопці ту саму геометрію, що й у таба:
  однаковий margin-top + висота одного таба. Центр кнопки збігається з центром
  таба незалежно від скролбару.
*/
.gt-tabs-row {
  display: flex;
  align-items: flex-start;
}
.gt-tabs-row > .dropdown {
  /* дублює margin-top у ul (інлайн-стиль на таббарі) — обидві коробки стартують з однієї лінії */
  margin-top: 8px;
  /* висота таба: padding 8px зверху/знизу + рядок тексту 13px * 1.5 (див. .gt-tabs .nav-link) */
  min-height: calc(13px * 1.5 + 16px);
  display: flex;
  align-items: center;
}

/*
  Список вибору колонок.
  .list-group-item має власний background-color: var(--vz-card-bg) — усередині
  дропдауна він накладався окремою плашкою на фон меню. Прибираємо, щоб рядки
  лежали прямо на фоні меню (і в темній темі теж).
  Клас-маркер gt-columns-menu потрібен, бо цей <style> не scoped — інакше
  правило зачепило б усі .list-group-item у застосунку.
*/
.gt-columns-menu .list-group-item {
  background-color: transparent;
}

/*
  Футер таблиці (варіант A) — один рядок замість двох поверхів.
  Було: підсумок окремим рядком (margin-top:20px) + пагінація нижче (mt-3) ≈ 110px.
  Стало: контроли ліворуч, підсумок притиснутий праворуч ≈ 44px — різниця йде під рядки.
*/
.gt-footer {
  display: flex;
  align-items: center;
  flex-wrap: wrap; /* на вузьких екранах футер переноситься, а не ламається */
  gap: 8px;
  /* Роздільника не додаємо: горизонтальний скролбар таблиці сам утворює лінію,
     і друга лінія одразу під ним виглядає як дубль. Достатньо чистого відступу. */
  margin-top: 25px;
  padding: 0 10px;
}
.gt-footer-total {
  font-size: 13px;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}
/* Праворуч притискаємо лише коли ліворуч є контроли; без пагінації підсумок лишається зліва */
.gt-footer-total:not(:first-child) {
  margin-left: auto;
}
/* Компактніші контроли — під висоту рядка таблиці (було ~38px) */
.gt-footer .form-select {
  height: 30px;
  padding-top: 0;
  padding-bottom: 0;
  font-size: 12.5px;
}
.gt-footer .listjs-pagination li .page {
  padding: 4px 9px;
  font-size: 12.5px;
  line-height: 1.5;
}

/*
  Єдина щільність рядків списків — ЗАВЖДИ однакова, незалежно від того, чи таблиця
  розтягнута на весь екран. Раніше щільність залежала від .gt-autoheight, через що
  рядки візуально "стрибали" (12px -> 7px), коли контент переставав вміщатися.
  Клас .table підвищує специфічність, щоб перекрити `.table > tbody > tr > td` з _table.scss.
  Рядки: 10px — 7px читалося занадто щільно, бейджі статусів/виконавців зливалися
  між сусідніми рядками. Шапка лишається компактнішою (7px), бо це не контент.
*/
.table.gt-table > tbody > tr > td {
  padding-top: 10px;
  padding-bottom: 10px;
}
.table.gt-table > thead > tr > th {
  padding-top: 7px;
  padding-bottom: 7px;
}
/* Компактніша єдина картка (панель інструментів + таблиця): менше padding і відступу */
.card:has(.table-responsive.table-card) {
  margin-bottom: 10px;
}
.card:has(.table-responsive.table-card) > .card-body {
  padding-top: 12px;
  padding-bottom: 12px;
}

/* Темна тема - покращена видимість тексту */
[data-layout-mode="dark"] .table tbody td {
  color: #ced4da;
}

[data-layout-mode="dark"] .noresult h5 {
  color: #ced4da;
}
</style>